export const sleep = (duration: number) =>
  new Promise((resolve) => setTimeout(resolve, duration));

export const getPathPrefixForNewsAndCommunity = (section: string) => {
  switch (section) {
    case 'community':
      return 'community';
    case 'changelog':
      return 'changelog';
    default:
      return 'blog';
  }
};
